import { DataSetConfig } from 'libs/end-to-end/src/types/databases/data-sets/data-set';
import { HTTP_INTEGRATION_DEFAULT_RETRY_COUNT } from 'libs/end-to-end/src/types/databases/data-sets/http-integration-defaults';
import { HTTP_INTEGRATION_DEFAULT_TIMEOUT_IN_SECONDS } from 'libs/end-to-end/src/types/databases/data-sets/http-integration-defaults';

export const createDefaultConfigForHttpIntegration = (): DataSetConfig => {
  return {
    dataSetType: 'Integration',
    integration: {
      integrationType: 'HTTP',
      urlList: [],
      timeoutInSeconds: HTTP_INTEGRATION_DEFAULT_TIMEOUT_IN_SECONDS,
      retryCount: HTTP_INTEGRATION_DEFAULT_RETRY_COUNT,
      customHeaderList: [],
      customHeadersWithSecrets: {
        headerName: '',
        headerSecretReference: undefined,
      },
    },
  };
};
